import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import { Spinner, Card, Alert } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import Utils from "../../services/Utils";
import SuiviClientAccordion from "../../components/suiviclient/SuiviClientAccordion";
import SuiviClientModal from "../../components/suiviclient/SuiviClientModal";
import { store } from "../../reducer/Store";
import ApiService from "../../services/ApiService";
import dayjs from "dayjs";

export default function SuiviClient() {
  const { dispatch, state } = React.useContext(store);
  const [show, setShow] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [isUpdate, setIsUpdate] = React.useState(false);
  const date = new Date();
  const [customerlog, setCustomerlog] = React.useState({
    customer_id:
      state.dataSelectedClient && state.dataSelectedClient.id
        ? state.dataSelectedClient.id
        : "",
    content: "",
    log_date: dayjs(date).format("YYYY-MM-DD"),
    author: JSON.parse(localStorage.getItem("user"))[0],
    id: "",
  });

  const handleClose = () => {
    setCustomerlog((prevState) => ({
      ...prevState,
      content: "",
      log_date: dayjs(date).format("YYYY-MM-DD"),
      id: "",
    }));
    setShow(false);
  };

  const handleShow = () => setShow(true);

  const setIdCustomerLog = (id) => {
    setCustomerlog((prevState) => ({
      ...prevState,
      id: id,
    }));
  };

  const handleShowUpdate = (customerlog) => {
    setIsUpdate(true);
    const dateFormat = customerlog.log_date.slice(0, 10);
    setCustomerlog((prevState) => ({
      ...prevState,
      content: customerlog.content,
      log_date: dateFormat,
      id: customerlog.id,
    }));
    handleShow();
  };
  /**
   * Réinitialise selectedInterlocutor avec des valeurs vides.
   * @param {*} e - L'événement de changement de valeur dans l'input.
   */
  const handleCustomerlogChange = (e, field) => {
    setCustomerlog((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };
  const handleAddCustomerLog = (e) => {
    setIsUpdate(false);
    setLoader(true);
    e.preventDefault();
    setCustomerlog({
      ...customerlog,
      customer_id: state.dataSelectedClient.id,
    });
    ApiService.request(customerlog, "customer-logs", "post")
      .then(function () {
        getAllCustomerLog();
        setLoader(false);
        Utils.notifySuccess("Ajout effectué.");
        handleClose();
      })
      .catch(function (error) {
        // manque un message q uand c'est une error
        console.log(error);
        setLoader(false);
      });
  };
  const handleUpdateCustomerLog = (e) => {
    setLoader(true);
    e.preventDefault();
    //on enlève l'id de dans le state pour garder que ce qu'on a besoin dans la requête
    const { id, ...data } = customerlog;

    ApiService.request(data, "customer-logs/" + customerlog.id, "put")
      .then(function () {
        getAllCustomerLog();
        setLoader(false);
        Utils.notifySuccess("Modification");
        handleClose();

        setIsUpdate(false);
      })
      .catch(function (error) {
        // manque un message quand c'est une
        Utils.notifyError("de la modification");
        console.log(error);
        setIsUpdate(false);
        setLoader(false);
      });
  };
  const getAllCustomerLog = async () => {
    setLoader(true);
    ApiService.request(
      {},
      "customer-logs-by-customer/" + state.dataSelectedClient.id,
      "get"
    )
      .then(function (response) {
        const getAllCustomerCare = response.data;
        dispatch({ type: "SET_CUSTOMERLOG", payload: getAllCustomerCare });
        setLoader(false);
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        Utils.notifyError("l'affichage de la liste des suivis.");
        console.log(error);
        setLoader(false);
      });
  };
  const deleteCustomerLog = (customerLogId) => {
    if (
      window.confirm("Êtes-vous sûr de vouloir supprimer ce suivi client ?")
    ) {
      setLoader(true);
      ApiService.request({}, "customer-logs/" + customerLogId, "delete")
        .then(function () {
          getAllCustomerLog();
          setLoader(false);
          Utils.notifySuccess("Suppression");
        })
        .catch(function (error) {
          // manque un message quand c'est une error
          Utils.notifyError("de la suppression.");
          console.log(error);
          setLoader(false);
        });
    }
  };
  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getAllCustomerLog();
    }
  }, [state.dataSelectedClient]);
  return (
    <>
      <h1>
        Suivi client
        {(parseInt(localStorage.getItem("user_role")) !== 5 &&
          parseInt(localStorage.getItem("user_role")) !== 6) && (
          <Dropdown className="d-inline-block">
            <Dropdown.Toggle>
              <MoreVertIcon />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                onClick={handleShow}
                disabled={
                  state.dataSelectedClient && state.dataSelectedClient.id
                    ? false
                    : true
                }
              >
                <AddCircleOutlineOutlinedIcon /> Ajouter
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        )}
      </h1>
      {show && (
        <SuiviClientModal
          show={show}
          action={
            customerlog.id !== ""
              ? "Modifier Suivi client"
              : "Ajouter Suivi client"
          }
          handleClose={handleClose}
          handleShow={handleClose}
          customerlog={customerlog}
          handleCustomerlogChange={handleCustomerlogChange}
          handleSubmitCustomerLog={
            isUpdate ? handleUpdateCustomerLog : handleAddCustomerLog
          }
        />
      )}
      <ToastContainer />

      {state.dataSelectedClient && state.dataSelectedClient.id ? (
        !loader ? (
          state.customerLogs &&
          state.customerLogs.map((customerlog, i) => (
            <SuiviClientAccordion
              key={i}
              customerlog={customerlog}
              handleShowUpdate={handleShowUpdate}
              customer_id={customerlog.customer_id}
              content={customerlog.content}
              log_date={customerlog.log_date}
              author={customerlog.author}
              deleteCustomerLog={deleteCustomerLog}
              setIdCustomerLog={setIdCustomerLog}
            />
          ))
        ) : (
          <div className="text-center pt-5">
            <Spinner
              animation={loader ? "border" : false}
              role="status"
            ></Spinner>
          </div>
        )
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner un client.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
}
